import React from 'react';
import PropTypes from 'prop-types';
import {
  CardText, FlatButton, AutoComplete, TextField, Checkbox, Toggle,
} from 'material-ui';
import moment from 'moment';
import { commitMutation, graphql } from 'react-relay';

import DateField from '../DateFieldComponent';
import environment from '../../relay/environment';
import search from '../../rest';

function addTraveler(input, onComplete) {
  commitMutation(
    environment,
    {
      mutation: graphql`
        mutation AddTraveler_AddTraveler_Mutation (
          $input: AddTravelerInput!
        ) {
          addTraveler(input: $input) {
            trip {
              numTravelers,
              tripName,
              primaryTravelerName,
              travelers {
                id,
                firstName,
                lastName,
                isPrimaryTraveler,
                primaryTravelerName,
                primaryTraveler {
                  id
                },
                birthdate,
                adult
              }
            }
          }
        }
      `,
      variables: { input },
      onCompleted: () => onComplete(),
      onError: err => alert(err),
    }
  );
}

export default class AddTraveler extends React.Component {
  static propTypes = {
    onComplete: PropTypes.func.isRequired,
    trip: PropTypes.shape().isRequired,
    index: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    const {
      isPrimaryTraveler,
      primaryTravelerId,
      primaryTravelerName,
    } = this.getPrimaryTraveler();

    this.state = {
      travelerAutocompleteData: [],
      profileAutocompleteData: [],
      id: '',
      fullName: '',
      displayName: '',
      firstName: '',
      lastName: '',
      email: '',
      birthdate: '',
      validDate: false,
      isAdult: true,
      isPrimaryTraveler,
      primaryTravelerId,
      primaryTravelerName,
      relationship: '',
      insideCircle: false,
      needsTraining: false,
      needsVetting: true,
    };
  }

  getPrimaryTraveler = () => {
    const { index } = this.props;
    const primaryTraveler = {
      isPrimaryTraveler: true,
      primaryTravelerId: '',
      primaryTravelerName: '',
    };

    if (index === 0) {
      return primaryTraveler;
    }

    const { trip: { travelers } } = this.props;
    const previous = travelers[index - 1];

    if (previous.isPrimaryTraveler) {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: previous.id,
        primaryTravelerName: `${previous.lastName}, ${previous.firstName}`,
      });
    } else if (previous.primaryTraveler !== null) {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: previous.primaryTraveler.id,
        primaryTravelerName: previous.primaryTravelerName,
      });
    } else {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: '',
        primaryTravelerName: previous.primaryTravelerName,
      });
    }

    return primaryTraveler;
  }

  cancel = () => {
    this.props.onComplete();
  }

  handleUpdateTravelerAutocomplete = (value) => {
    search('auto/traveler', value).then((response) => {
      const { objects } = response;
      this.setState({
        travelerAutocompleteData: objects.map((object) => {
          const emailString = object.email[0] !== '' ? ` (${object.email})` : '';
          const displayName = object.displayName || object.fullName;
          const text = `${displayName}${emailString}`;

          return {
            text,
            value: object.relayId,
            fullName: object.fullName,
            displayName: object.displayName,
            firstName: object.firstName,
            lastName: object.lastName,
            email: object.email[0],
            birthdate: object.birthdate,
            isAdult: object.adult,
            isPrimaryTraveler: object.isPrimaryTraveler,
            primaryTravelerId: object.primaryTravelerId,
            primaryTravelerName: object.primaryTravelerName,
            relationship: object.relationship,
          };
        }),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  travelerSelected = (selected, index) => {
    if (index !== -1) {
      const { trip: { id: tripId }, onComplete } = this.props;
      const {
        value: travelerId, firstName, lastName, email = '', birthdate, isAdult,
        isPrimaryTraveler, primaryTravelerId, primaryTravelerName, relationship,
      } = selected;

      addTraveler({
        tripId,
        travelerId,
        firstName,
        lastName,
        email,
        birthdate,
        isAdult,
        isPrimaryTraveler,
        primaryTravelerId,
        primaryTravelerName,
        relationship,
      }, onComplete);
    }
  }

  handleUpdateProfileAutocomplete = (value) => {
    search('auto/traveler', `${value}&primary=true`).then((response) => {
      const { objects } = response;
      this.setState({
        primaryTravelerId: '',
        primaryTravelerName: value,
        profileAutocompleteData: objects.map(object => ({
          text: `${object.lastName}, ${object.firstName}`,
          value: object.relayId,
          firstName: object.firstName,
          lastName: object.lastName,
        })),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  profileSelected = (selected, index) => {
    if (index === -1) {
      this.setState({
        primaryTravelerId: '',
        primaryTravelerName: selected,
      });
    } else {
      const { value: primaryTravelerId, firstName, lastName } = selected;
      const primaryTravelerName = `${lastName}, ${firstName}`;

      this.setState({
        primaryTravelerId,
        primaryTravelerName,
      });
    }
  }

  updateTextField = fieldName => (e) => {
    const { target: { value } } = e;
    const newState = this.state;
    newState[fieldName] = value;
    this.setState(newState);
  }

  updateBirthdate = (e) => {
    const { target: { value } } = e;
    const { isAdult } = this.state;
    const validDate = moment(value).isValid();

    this.setState({
      birthdate: value,
      validDate,
      isAdult: validDate ? moment().diff(moment(value), 'years') > 17 : isAdult,
    });
  }

  handleIsAdult = (e, checked) => {
    this.setState({ isAdult: checked });
  }

  togglePrimaryTraveler = (e) => {
    const { target: { checked } } = e;
    this.setState({
      isPrimaryTraveler: checked,
      primaryTravelerId: '',
      primaryTravelerName: '',
    });
  }

  save = () => {
    const { trip: { id: tripId }, onComplete } = this.props;
    const {
      firstName, lastName, email, birthdate, isAdult, isPrimaryTraveler,
      primaryTravelerId, primaryTravelerName, relationship, insideCircle,
      needsTraining, needsVetting,
    } = this.state;

    addTraveler({
      tripId,
      firstName,
      lastName,
      email,
      birthdate,
      isAdult,
      isPrimaryTraveler,
      primaryTravelerId,
      primaryTravelerName,
      relationship,
      insideCircle,
      needsTraining,
      needsVetting,
    }, onComplete);
  }

  handleCheckbox = fieldname => (e, checked) => {
    const newState = {};
    newState[fieldname] = checked;
    this.setState(newState);
  }

  render() {
    const {
      travelerAutocompleteData, id, firstName, lastName, email,
      isAdult, validDate, isPrimaryTraveler, primaryTravelerName,
      profileAutocompleteData, relationship, insideCircle, needsTraining,
      needsVetting,
    } = this.state;
    const ready = id || email || (firstName && lastName);

    return (<div>
      <CardText>
        <AutoComplete
          hintText='Search for an existing traveler'
          menuStyle={{ width: 500 }}
          listStyle={{ width: 500 }}
          dataSource={travelerAutocompleteData}
          onUpdateInput={this.handleUpdateTravelerAutocomplete}
          onNewRequest={this.travelerSelected}
          fullWidth
          filter={() => true}
        />
        <div style={styles.formFieldsStyle}>
          <TextField
            style={styles.formFieldStyle}
            value={lastName}
            floatingLabelText='Last Name'
            onChange={this.updateTextField('lastName')}
          />
          <TextField
            style={styles.formFieldStyle}
            value={firstName}
            floatingLabelText='First Name'
            onChange={this.updateTextField('firstName')}
          />
          <TextField
            style={styles.formFieldStyle}
            value={email}
            floatingLabelText='Email Address'
            onChange={this.updateTextField('email')}
          />
          <div style={styles.formFieldGroupStyle}>
            <DateField
              style={styles.formFieldStyle}
              floatingLabelText='Birthdate'
              onChange={this.updateBirthdate}
            />
            <Checkbox
              style={styles.formCheckboxStyle}
              checked={isAdult}
              label='Adult'
              onCheck={this.handleIsAdult}
              disabled={validDate}
            />
          </div>
          <div style={styles.formFieldStyle}>
            <Toggle
              checked={isPrimaryTraveler}
              onClick={this.togglePrimaryTraveler}
              label='CB+ Profile'
              labelPosition='right'
            />
            {isPrimaryTraveler ? null : <AutoComplete
              floatingLabelText='CB+ Profile Name'
              menuStyle={{ width: 500 }}
              listStyle={{ width: 500 }}
              searchText={primaryTravelerName}
              dataSource={profileAutocompleteData}
              onUpdateInput={this.handleUpdateProfileAutocomplete}
              onNewRequest={this.profileSelected}
              fullWidth
              filter={() => true}
            />}
            {isPrimaryTraveler ? null : <TextField
              floatingLabelText='Traveler Relationship'
              value={relationship}
              onChange={this.updateTextField('relationship')}
            />}
          </div>
          <div style={styles.formFieldStyle}>
            <Checkbox
              checked={insideCircle}
              label='Inside Circle'
              onCheck={this.handleCheckbox('insideCircle')}
            />
          </div>
          <div style={styles.formFieldStyle}>
            <Checkbox
              checked={needsTraining}
              label='Needs Training'
              onCheck={this.handleCheckbox('needsTraining')}
            />
          </div>
          <div style={styles.formFieldStyle}>
            <Checkbox
              checked={needsVetting}
              label='Needs Vetting'
              onCheck={this.handleCheckbox('needsVetting')}
            />
          </div>
        </div>

        <div style={styles.formActionsStyle}>
          <FlatButton
            label='Cancel'
            secondary
            onTouchTap={this.cancel}
          />
          <FlatButton
            label='Confirm'
            primary
            onTouchTap={this.save}
            disabled={!ready}
          />
        </div>
      </CardText>
    </div>);
  }
}

const styles = {
  formFieldsStyle: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
  formFieldStyle: {
    width: 256,
    marginRight: 'auto',
  },
  formCheckboxStyle: {
    width: 256,
    alignSelf: 'flex-end',
  },
  formActionsStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  formFieldGroupStyle: {
    width: 256,
  },
};



// WEBPACK FOOTER //
// /src/components/Trips/AddTraveler.js